export default __webpack_public_path__ + "static/msta-6e362e64bbaac33fbb21f5f6a66b6a1e.png";